import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { Component, DestroyRef, EventEmitter, inject, Inject, Input, OnInit, Output, signal } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardContent, MatCardModule } from '@angular/material/card';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSelectItems } from '../../../interfaces/lookup';
import { FeedstockService } from '../../../services/feedstockservice';
import { DepackService } from '../../../services/depack.service';
import { IdName } from '../../../interfaces/pricematrixmodel';
import { SelectSearchComponent } from '../../shared/components/select-search/select-search.component';
import { AddDepackStreamDialogData, DepackStreamGridResponse, GetPriceMatrixForStreamResponse } from '../../../interfaces/feedstocklistmodel';
import { AddeditStreamComponent } from '../../feedstock/streams/addedit-stream/addedit-stream.component';
import { PriceMatrixService } from '../../../services/pricematrix.service';
import { AlertDialogComponent } from '../../shared/components/alert-dialog/alert-dialog.component';
import { LookUpService } from '../../../services/lookupservice';
import { MaterialUnitOfMeasureLookupResponse } from '../../../interfaces/haulerModel';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SaveAttemptErrorMatcher } from '../../shared/commonutils/errorStateDirective';
import { numericInputLimit } from '../../shared/commonutils/helper';

@Component({
  selector: 'app-add-edit-stream',
  imports: [CommonModule, FormsModule, MatDialogModule, MatFormFieldModule,
    MatInputModule, MatSelectModule, MatButtonModule, MatIconModule, MatCardContent,
    MatCardModule, DragDropModule, SelectSearchComponent, ReactiveFormsModule,
    DragDropModule],
  templateUrl: './add-edit-stream.component.html',
  styleUrl: './add-edit-stream.component.scss'
})
export class AddEditStreamComponent implements OnInit {
  streamId: number | null = null;
  selectStreamItems: MatSelectItems[] = [];
  uomsLookup: MaterialUnitOfMeasureLookupResponse[] = [];
  attemptSave = signal(false);
  displayValue = signal<string>('');
  public matcher = new SaveAttemptErrorMatcher(() => this.attemptSave());
  upsertDepackStream!: FormGroup;
  streamPMDetails!: GetPriceMatrixForStreamResponse;
  loadPMDetails: any;

  isUOMDisabled!: true;
  isRebateUOMDisabled!: true;
  private destroyRef = inject(DestroyRef);

  constructor(private fsService: FeedstockService,
    private depackService: DepackService,
    private pmService: PriceMatrixService,
    private lookupService: LookUpService,
    private fb: FormBuilder,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: AddDepackStreamDialogData,
    public dialogRef: MatDialogRef<AddeditStreamComponent>
  ) {
    console.log("ip data", data);
  }

  ngOnInit(): void {
    this.getRebateUnitsOfmeasureData();
    this.initializeForm();
    this.getStreamsLookup();

    if (this.data.mode == 'Edit') {
      this.getStreamById();
    }
  }

  initializeForm(): void {
    this.upsertDepackStream = this.fb.group({
      id: [0], //additional streamid
      pmId: [null, Validators.required],
      streamId: [null, Validators.required],

      tipFee_UOM_Id: [{ value: null, disabled: true }],
      tipFee: [{ value: null, disabled: true }],
      quantity: [null, Validators.required],
      
      rebate_UOM_Id: [{ value: null, disabled: true }],
      rebateValue: [{ value: null, disabled: true }],
      rebateQuantity: [{value:null, disabled: true}],
      haulRev: [0]
    })
  }

  getStreamsLookup() {
    this.depackService.getStreamsForDepack(this.data.generatorId, this.data.locName, this.data.hid, this.data.sid).subscribe({
      next: async (response: IdName[]) => {

        this.selectStreamItems = response.map(item => ({
          id: item.id,
          name: item.name!
        }));
      }
    })
  }

  getPriceMatrixDetailsForStream() {
    this.pmService.getPriceMatrixDetailsForStream(
      this.data.generatorId, this.streamId!, this.data.sid, this.data.hid, this.data.actualDate
    ).subscribe({
      next: async (response: GetPriceMatrixForStreamResponse) => {
        console.log("addt PM data", response);
        if(response != null){
          this.streamPMDetails = response;
          const rebateUomId = response.rebate_UOM && response.rebate_UOM > 0 ? Number(response.rebate_UOM) : null;

          this.upsertDepackStream.patchValue({
            pmId: response.id,
            tipFee: response.tipFee,
            tipFee_UOM_Id: Number(response.tipFee_UOM),
            rebate_UOM_Id: rebateUomId,
            rebateValue: response.rebateValue,
            haulRev: response.haul_Rate_Perload ?? 0
          });
    
          // force disabled controls refresh
          this.upsertDepackStream.get('tipFee')?.updateValueAndValidity();
          this.upsertDepackStream.get('rebateValue')?.updateValueAndValidity();
          this.updateRebateControls(rebateUomId);
        }
      }
    })
  }

  getStreamById() {
    const res = this.data.streamRecord;
    this.upsertDepackStream.patchValue({
      id: res.id,
      pmId: res.aPriceMatrixId,
      streamId: res.streamID,
      tipFee: res.tipFee,
      tipFee_UOM_Id: res.uom,
      rebate_UOM_Id: res.aD_RebateUOM,
      rebateValue: res.rebateValue,
      quantity: res.quantity,
      rebateQuantity: res.aD_RebateQty
    });
    if(res.aD_RebateUOM !== null){
      this.updateRebateControls(res.aD_RebateUOM);
    }
  }

  private updateRebateControls(rebateUomId: number | null): void {
    const rebateQtyCtrl = this.upsertDepackStream.get('rebateQuantity');
    const rebateValueCtrl = this.upsertDepackStream.get('rebateValue');
  
    if (rebateUomId && rebateUomId > 0) {
      rebateQtyCtrl?.enable();
    } else {
      rebateQtyCtrl?.clearValidators();
      rebateQtyCtrl?.setValue(null);
      rebateQtyCtrl?.disable();
  
      rebateValueCtrl?.setValue(null);
    }
    rebateValueCtrl?.updateValueAndValidity();
  }

  //Cancel dialog
  onCancel(): void {
    this.dialogRef.close(null);
  }

  onStreamReceived(event: number | null) {
    this.streamId = event;
    this.onStreamSelectionChange();
  }


  getRebateUnitsOfmeasureData() {
    {
      this.lookupService.getMaterialUnitOfMeasureLookup(0).subscribe({
        next: async (response: MaterialUnitOfMeasureLookupResponse[]) => {
          this.uomsLookup = response;
        }
      })
    }
  }

  onStreamSelectionChange() {
    this.getPriceMatrixDetailsForStream();
  }

  onSave() {
    this.upsertDepackStream.markAllAsTouched();
    this.attemptSave.set(true);
    this.upsertDepackStream.markAsDirty();
    this.upsertDepackStream.markAllAsTouched();
    if (this.upsertDepackStream.invalid) {
      return;
    }

    const formVal = this.upsertDepackStream.getRawValue();
    const editRow = this.data.streamRecord;
    const alreadyExists = this.data.existingStreams?.find((x: any) => {
    const sameStream = (x.streamID ?? x.streamId) === formVal.streamId;    
    const sameRow =
      editRow &&
      (
        (x.id && editRow.id && x.id === editRow.id) ||
        (x.tempKey && editRow.tempKey && x.tempKey === editRow.tempKey)
      );
    
      return sameStream && !sameRow;
    });
  
    if (alreadyExists) {
      this.dialog.open(AlertDialogComponent, {
        data: {
          title: 'Alert',
          message: `'${alreadyExists.streamName}' is already added.`
        },
        disableClose: true,
        panelClass: 'delete-confirmation-dialog-nowrap'
      });
      return;
    }


    const raw = this.upsertDepackStream.getRawValue();
    const selectedStream = this.selectStreamItems.find(s => s.id === raw.streamId);
    const tipFee_UOM = this.uomsLookup.find(u => u.id === raw.tipFee_UOM_Id);
    const rebate_UOM = this.uomsLookup.find(u => u.id === raw.rebate_UOM_Id);
    let rebateTotal: number = 0;
    let tipFeeTotal: number = 0;
    let total: number = 0;

    if (raw.rebateQuantity && raw.rebateValue) {
      rebateTotal = Number(
        (Number(raw.rebateQuantity) * Number(raw.rebateValue)).toFixed(4)
      );
    }

    if (raw.quantity && raw.tipFee) {
      tipFeeTotal = Number(
        (Number(raw.quantity) * Number(raw.tipFee)).toFixed(4)
      );
    }

    total = Number((tipFeeTotal - rebateTotal).toFixed(4));

    const streamRecord: DepackStreamGridResponse = {
      id: raw.id,
      aPriceMatrixId: raw.pmId,
      fSLoadID: this.data.fsLoadId,
      streamID: raw.streamId,
      streamName: selectedStream?.name ?? '',
      uom: raw.tipFee_UOM_Id,
      uomText: tipFee_UOM?.name ?? '',
      quantity: raw.quantity,
      tipFee: raw.tipFee,
      aD_RebateUOM: raw.rebate_UOM_Id,
      aD_RebateUOMText: rebate_UOM?.name ?? '',
      aD_RebateQty: raw.rebateQuantity,
      rebateValue: raw.rebateValue,
      rebateTotal: rebateTotal,
      total: total,
      tempKey: this.data.streamRecord?.tempKey,
      haulRev: raw.haulRev
    };

    this.dialogRef.close(streamRecord);
  }

  roundOff(event: Event, maxValue: number, maxDecimals: number, controlName: string): void {
    const input = event.target as HTMLInputElement;
    let val = input.value;

    val = numericInputLimit(event, maxValue, maxDecimals);

    this.displayValue.set(val);
    input.value = val;

    // 6. Parsing for the backing variables
    const isValueEmpty = val === '' || val === '.';
    if (isValueEmpty) {
      this.upsertDepackStream.get(controlName)?.setValue(null, { emitEvent: false });
    } else if (val.endsWith('.')) {
      this.upsertDepackStream.get(controlName)?.setErrors({ 'incompleteDecimal': true });
    } else {
      const parsedValue = parseFloat(val);
      this.upsertDepackStream.get(controlName)?.setValue(parsedValue, { emitEvent: false });
    }
    requestAnimationFrame(() => {
      if (document.activeElement === input) {
          input.value = val;
      }
    });
  }
}

